module.exports = __webpack_public_path__ + "img/road-trip-3.59446639.jpg";